import React from "react";
import { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import { ApplicationPaths, QueryParameterNames } from "./ApiAuthorizationConstants";
import authService from "./AuthorizeService";
import authApiService from '../../adapters/xhr/AuthApiService';

export default class AuthorizeRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      didGetAntiforgeryToken: false,
      authenticated: false
    };
  }

  componentDidMount() {
    authApiService.createAntiforgeryToken(() => this.setState({didGetAntiforgeryToken: true}));
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.didGetAntiforgeryToken === true && prevState.didGetAntiforgeryToken === false) {
      this._subscription = authService.subscribe(() => this.authenticationChanged());
      this.populateAuthenticationState();
    }
  }

  render() {
    const { ready, didGetAntiforgeryToken, authenticated } = this.state;
    var link = document.createElement("a");
    link.href = this.props.path;
    const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
    // const redirectUrl = this.props.redirectUrl ?? `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(returnUrl)}`;
    const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(returnUrl)}`;
    if (!ready || !didGetAntiforgeryToken || !authenticated) {
      return <div></div>;
    } else {
      const { component: Component, layout: Layout, ...rest } = this.props;
      return (
        <Route
          {...rest}
          render={(props) => {
              if (Layout) {
                return (
                  <Layout>
                    <Component {...props} />
                  </Layout>
                );
              } else {
                return <Component {...props} />;
              }
          }}
        />
      );
    }
  }

  async populateAuthenticationState() {
    const authenticated = await authService.isAuthenticated();
    this.setState({ ready: true, authenticated: authenticated });
  }

  async authenticationChanged() {
    this.setState({ ready: false, authenticated: false });
    await this.populateAuthenticationState();
  }
}
